import { useContext } from 'react'

import CurrentSubmissionIdProvider, { CurrentSubmissionIdContext } from './Provider'

export { CurrentSubmissionIdProvider, CurrentSubmissionIdContext }
export type { ICurrentSubmissionIdContextProps } from './Provider'

export const useCurrentSubmissionId = () => useContext(CurrentSubmissionIdContext)
